import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-content-page',
  templateUrl: './no-content-page.component.html',
  styleUrls: ['./no-content-page.component.scss'],
  standalone: false
})
export class NoContentPageComponent {
  @Input() message = 'No content available.';
}
